<template>
  <div class="archive20231003" v-if="info">
    <v-container>
      <div v-for="(info, index) in info" :key="index">
        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="10" xl="8">
            <div class="heading text-h4 pl-4">{{ formatDate(info.date) }} {{ info.title }}</div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <div>
              <div class="text-h6">{{ info.subtitle }}</div>
              <a href="https://www.ai-gakkai.or.jp/jsai2024/" target="_blank">JSAI2024 – 2024年度 人工知能学会全国大会（第38回）</a>       
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <v-row class="my-4" justify="center">
                <v-col cols="12" md="8">
                    <v-img
                    :src="require(`@/assets/archives_images/20240531_1.jpg`)"
                    eager
                    ></v-img>
                    <v-img
                    :src="require(`@/assets/archives_images/20240531_2.jpg`)"
                    eager
                    ></v-img>
                    <v-img
                    :src="require(`@/assets/archives_images/20240531_3.jpg`)"
                    eager
                    ></v-img>
                    <v-img
                    :src="require(`@/assets/archives_images/20240531_4.jpg`)"
                    eager
                    ></v-img>
                    <v-img
                    :src="require(`@/assets/archives_images/20240531_5.jpg`)"
                    eager
                    ></v-img>
                    <v-img
                    :src="require(`@/assets/archives_images/20240531_6.jpg`)"
                    eager
                    ></v-img>
                </v-col>
            </v-row>
          </v-col>
        </v-row>

      </div>
    </v-container>
  </div>
</template>

<script>
// 共通のJavaScriptファイルをインポート
import commonScript from "./common/CommonScript.js";

export default {
  mixins: [commonScript], // 共通スクリプトをミックスイン
};
</script>

<style scoped>
/* 共通のCSSファイルをインポート */
@import url("./common/CommonStyles.css");
</style>